export interface VideoCategory {
  slug: string;
  name: string;
  description: string;
  icon: string;
}

export const categories: VideoCategory[] = [
  {
    slug: 'drama',
    name: '热门剧集',
    description: '最新最热门的电视剧集，每日更新',
    icon: 'ri-movie-2-line',
  },
  {
    slug: 'movie',
    name: '电影大片',
    description: '院线大片、经典电影一网打尽',
    icon: 'ri-film-line',
  },
  {
    slug: 'variety',
    name: '综艺娱乐',
    description: '热门综艺、搞笑娱乐节目',
    icon: 'ri-emotion-laugh-line',
  },
  {
    slug: 'anime',
    name: '动漫番剧',
    description: '国产动漫、日本番剧精选',
    icon: 'ri-ancient-gate-line',
  },
  {
    slug: 'documentary',
    name: '纪录片',
    description: '自然、历史、人文纪录片',
    icon: 'ri-earth-line',
  },
  {
    slug: 'short',
    name: '短视频',
    description: '精彩短视频、创意内容',
    icon: 'ri-vidicon-line',
  },
  {
    slug: 'music',
    name: '音乐MV',
    description: '华语金曲、流行MV精选',
    icon: 'ri-music-2-line',
  },
  {
    slug: 'kids',
    name: '少儿频道',
    description: '儿童动画、早教内容',
    icon: 'ri-bear-smile-line',
  },
];